import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, CircularProgress } from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_BLACK, COLOR_GREY_2 } from "shared/theme/colors";
import { StyledChip } from "./styled";

type ChipProps = {
  title: string | React.ReactNode;
  bgColor?: string;
  borderColor?: string;
  isLoading?: boolean;
  withDropdownArrow?: boolean;
  isOpen?: boolean;
};

const Chip: FC<ChipProps> = ({
  bgColor,
  title,
  isLoading,
  borderColor,
  withDropdownArrow = false,
  isOpen = false,
}) => (
  <StyledChip
    bgColor={isLoading ? COLOR_GREY_2 : bgColor}
    borderColor={borderColor}
  >
    {isLoading ? (
      <CircularProgress color={"success"} size={12} />
    ) : (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography variant="bodySMedium" color={COLOR_BLACK}>
          {title}
        </Typography>
        {withDropdownArrow && (
          <KeyboardArrowDownIcon
            fontSize="small"
            sx={{
              color: COLOR_BLACK,
              transition: "transform 0.2s",
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
              fontSize: "16px",
            }}
          />
        )}
      </Box>
    )}
  </StyledChip>
);

export default Chip;
